import styled from 'styled-components';
import { colors } from '~/styles/remoteControlColors';

export const OnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: -30px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

export const Slide = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
  margin-top: -32px;
`;

export const Slider = styled.div<{ currentStep: number }>`
  display: flex;
  width: 100%;
  transition: transform 0.4s ease-in-out;
  transform: ${({ currentStep }) => `translateX(-${(currentStep - 1) * 100}%)`};
`;

export const Step = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: start;

  div {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: start;
  }

  img {
    height: 353px;
    width: 390px;
    object-fit: cover;
  }

  h2, p {
    margin: 0;
    text-align: center;
    line-height: 180%;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    color: ${colors.Black900};
  }

  p {
    font-weight: 400;
    font-size: 14px;
    color: ${colors.Grey500};
  }

  @media (max-width: 768px) {
    padding: 0;
    height: calc(100dvh - 220px);

    div {
      padding: 0 24px;
      margin: auto 0;
    }

    img {
      width: 100%;
    }

    p {
      max-width: 310px;
    }
  }
`;
